import { RideOrganizer } from '../../types/rides';

export const getLeadOrganizerName = (organizers: RideOrganizer[]): string => {
  const leadOrganizer = getLeadOrganizer(organizers);

  return leadOrganizer?.firstName ? `${leadOrganizer.firstName} ${leadOrganizer.lastName}` : '';
};

const getLeadOrganizer = (organizers: RideOrganizer[]): RideOrganizer => {
  return organizers.find((organizer) => organizer.leadOrganizer) || organizers[0];
};
